import { Firestore, Timestamp, Functions } from '../firebase';
import $ from 'jquery';
import store from '@/store';
import { v4 as uuidv4 } from 'uuid';

export default {
  data() {
    return {
      search: '',
      showAlert: false,
      alert: {
        class: 'alert-danger',
        text: 'Hubo un error. Intenta de nuevo.'
      }
    };
  },

  beforeMount() {
    $('.dropdown-toggle').dropdown();

    if (this.$route.query.search) this.search = this.$route.query.search;
  },

  computed: {
    database() {
      return Firestore.collection('companies').doc(this.$store.state.company.id);
    },
    getMonthString() {
      const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ];
      let current = new Date().getMonth();
      return months[current] + ', ' + new Date().getFullYear();
    }
  },

  methods: {
    filterArray(array, properties) {
      return array.filter(item => item[properties[0]].toLowerCase().includes(this.search));
    },

    setAlert(className, text, redirect) {
      this.alert.class = className;
      this.alert.text = text;
      this.triggerAlert(redirect).then((this.showAlert = true));
    },

    triggerAlert(redirect) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve('yei!');
          reject('ups!');
          this.showAlert = false;

          if (redirect) {
            if (redirect === 'back') {
              this.$router.go(-1);
            } else {
              this.$router.push(redirect);
            }
          }
        }, 1000);
      });
    },

    fetchDocument(collection, id) {
      return this.database
        .collection(collection)
        .doc(id)
        .get()
        .then(doc => {
          return { id: doc.id, ...doc.data() };
        });
    },

    fetchCollection(collection) {
      let array = [];
      if (collection === 'companies') {
        this.database.onSnapshot(snapshot =>
          snapshot.forEach(doc => {
            array.push({ id: doc.id, ...doc.data() });
          })
        );
      } else {
        this.database
          .collection(collection)
          .orderBy('created', 'desc')
          .onSnapshot(snapshot =>
            snapshot.forEach(doc => {
              array.push({ id: doc.id, ...doc.data() });
            })
          );
      }

      return array;
    },

    fetchTableData(collection, orderBy, limit) {
      let first = this.database
        .collection(collection)
        .orderBy(orderBy)
        .limit(limit);

      return first.get().then(documentSnapshots => {
        let last = documentSnapshots.docs[documentSnapshots.docs.length - 1];
        return this.database
          .collection(collection)
          .orderBy(orderBy)
          .startAfter(last)
          .limit(limit);
      });
    },

    submit(collection, action, data) {
      const database = Firestore.collection('companies').doc(this.$store.state.company.id);

      if (collection === 'company') {
        if (action === 'update') database.update(data);
        this.$store.dispatch('client/setData');
      } else {
        // On create
        if (action === 'create') {
          data.created = Timestamp;
          return database.collection(collection).add(data);
        }
        // On update
        if (action === 'update') {
          const id = data.id;
          delete data.id;
          database
            .collection(collection)
            .doc(id)
            .update(data);
        }
        // on delete
        if (action === 'delete') {
          database
            .collection(collection)
            .doc(data)
            .delete();
        }
      }

      this.$forceUpdate();
    },

    sendEmail(func, data) {
      const callable = Functions.httpsCallable(func);
      callable(data);
      // .then(console.log('email sent!')).catch(error => console.log(error))
    },

    /* Crear form data para creacion de cotizacion */
    createQuote(quoteClients, ivaValue) {
      let formData = new FormData();
      formData.append('title', this.quote.title);
      formData.append('discount', this.quote.discount);
      formData.append('iva', this.quote.tax == true ? 1 : 0);
      formData.append('currency', this.quote.currency);
      formData.append('days_validity', this.quote.validDays);
      let clientsIds = [];
      quoteClients.forEach(element => {
        clientsIds.push(element.id);
      });
      formData.append('clients', clientsIds);
      formData.append('user_id', this.quote.from.id);
      formData.append('percentage_iva', ivaValue);
      return formData;
    },

    /* Crear form data para un objeto de tipo producto en cotizacion ya sea plantilla o cotizacion */
    createQuoteItemsProducts(quote, total, isTemplate) {
      var itemsProducts = [];
      var itemsText = [];
      quote.items.forEach((item, index) => {
        if (item.type == 'producto') {
          itemsProducts.push(this.parseObjectProducto(item, index));
        } else {
          itemsText.push(this.parseObjectTexto(item, index));
        }
      });

      let formData = new FormData();

      if (!isTemplate) {
        formData.append('quotation_uuid', quote.quoteId);
      } else {
        formData.append('template_quotation_uuid', quote.quoteId);
      }

      if (itemsProducts.length > 0) {
        formData.append('items_products', JSON.stringify(itemsProducts));

        itemsProducts.forEach((element, indexParent) => {
          if (element.attachments != undefined) {
            element.attachments.forEach(file => {
              formData.append('items_products_attachments[' + indexParent + '][]', file);
            });
          }
        });
      }

      if (itemsText.length > 0) {
        formData.append('items_text', JSON.stringify(itemsText));
        itemsText.forEach(element => {
          if (element.attachments != undefined) {
            itemsText.forEach((element, indexParent) => {
              if (element.attachments != undefined) {
                element.attachments.forEach(file => {
                  formData.append('items_text_attachments[' + indexParent + '][]', file);
                });
              }
            });
          }
        });
      }

      if (quote.note != null) {
        if (quote.note_id != null) {
          formData.append(
            'items_quote',
            JSON.stringify([
              {
                description: quote.note,
                id: quote.note_id
              }
            ])
          );
        } else {
          formData.append(
            'items_quote',
            JSON.stringify([
              {
                description: quote.note
              }
            ])
          );
        }
      }

      formData.append('quote_total', total);

      return formData;
    },

    /* Formatear objetos producto y texto a nuevo formato de backend */
    parseObjectProducto(item, index) {
      let itemProducto = {
        sku: '',
        category_id: 0,
        name: '',
        description: '',
        IVA: 0,
        unit_price: 0,
        quantity: 0,
        is_optional: 0,
        is_client_select: 0,
        quantity_editable: 0,
        has_discount: 0,
        has_subscription: 0,
        has_commission: 0,
        order: 0
      };
      if (item.id != null) {
        itemProducto.id = item.id;
      }
      itemProducto.sku = item.sku;
      itemProducto.category_id = item.category;
      itemProducto.name = item.title;
      itemProducto.description = item.description;
      itemProducto.IVA = item.tax == true ? 1 : 0;
      itemProducto.quantity = item.quantity.amount;
      itemProducto.unit_price = item.price;
      itemProducto.is_optional = item.optional.active == true ? 1 : 0;
      itemProducto.client_select =
        item.optional.active != true ? 1 : item.optional.select == true ? 1 : 0;
      itemProducto.quantity_editable = item.quantity.edit == true ? 1 : 0;
      itemProducto.has_discount = item.discount.active == true ? 1 : 0;
      itemProducto.has_subscription = item.suscription.active == true ? 1 : 0;
      itemProducto.has_commission = item.commission.active == true ? 1 : 0;
      itemProducto.order = index + 1;
      if (item.attachments.length > 0) {
        let arrayAtatchments = [];
        item.attachments.forEach(element => {
          if (element.file != null && element.file != 'null' && element.file != '') {
            arrayAtatchments.push(element.file);
          } else {
            arrayAtatchments.push(element.base64);
          }
        });
        itemProducto.attachments = arrayAtatchments;
      }
      /* Checar descuento */
      if (item.discount.active == true) {
        itemProducto.discount = item.discount.amount;
      }
      /* Checar comision */
      if (item.commission.active == true) {
        itemProducto.commission = item.commission.amount;
      }

      if (item.suscription.active == true) {
        itemProducto.frequency = item.suscription.repetition;
        itemProducto.period = item.suscription.frequency;
      }

      return itemProducto;
    },

    parseObjectTexto(item, index) {
      let itemTexto = {
        name: '',
        description: '',
        order: 0
      };

      if (item.id != null) {
        itemTexto.id = item.id;
      }
      itemTexto.name = item.title;
      itemTexto.description = item.description;
      itemTexto.order = index + 1;
      if (item.attachments.length > 0) {
        let arrayAtatchments = [];
        item.attachments.forEach(element => {
          if (element.file != null) {
            arrayAtatchments.push(element.file);
          } else {
            arrayAtatchments.push(element.base64);
          }
        });
        itemTexto.attachments = arrayAtatchments;
      }

      return itemTexto;
    },

    /* Formatear objeto default de servicio backend a formato original de proyecto*/
    formatItem(item, type) {
      var tempId = null;

      if (item.id != null) {
        tempId = item.id;
      }

      if (type == 'product') {
        var tempAttatchments = [];

        try {
          var decoded = JSON.parse(item.attachments);
          if (decoded.length > 0) {
            decoded.forEach(element => {
              var tempFileName = element.split('/');
              tempAttatchments.push({
                file: null,
                base64: element,
                fileName: tempFileName[tempFileName.length - 1],
                type:
                  element.toLowerCase().indexOf('jpg') > -1 ||
                  element.toLowerCase().indexOf('jpeg') > -1 ||
                  element.toLowerCase().indexOf('png') > -1
                    ? 'image'
                    : 'file'
              });
            });
          }
        } catch (e) {
          if (item.attachments != null) {
            if (item.attachments.length > 0) {
              item.attachments.forEach(element => {
                var tempFileName = element.url.split('/');
                tempAttatchments.push({
                  file: null,
                  base64: element.url,
                  fileName: tempFileName[tempFileName.length - 1],
                  type:
                    element.url.toLowerCase().indexOf('jpg') > -1 ||
                    element.url.toLowerCase().indexOf('jpeg') > -1 ||
                    element.url.toLowerCase().indexOf('png') > -1
                      ? 'image'
                      : 'file'
                });
              });
            }
          }
        }

        const product = {
          key: uuidv4(),
          id: tempId,
          type: 'producto',
          sku: item.sku == null || item.sku == 'null' || item.sku == '' ? '' : item.sku,
          title: item.name,
          description:
            item.description == null || item.description == 'null' || item.description == ''
              ? ''
              : item.description,
          category: item.category_id,
          tax: item.iva == 1 ? true : false,
          optional: {
            active: item.is_optional == 1 ? true : false,
            select: item.client_select == 1 ? true : false
          },
          discount: {
            amount: item.discount != 0 ? item.discount : null,
            active: item.has_discount == 1 ? true : false
          },
          suscription: {
            active: item.has_subscription == 1 ? true : false,
            payments: null,
            frequency: item.period,
            repetition: item.frequency
          },
          commission: {
            amount:
              item.commission != null || item.commission > 0 ? parseInt(item.commission) : null,
            active: item.has_commission == 1 ? true : false
          },
          price: parseFloat(item.unit_price),
          quantity: {
            amount: item.quantity,
            edit: item.quantity_editable == 1 ? true : false
          },
          total: 0,
          attachments: tempAttatchments,
          errors: null,
          order: this.quote.items.length + 1
        };

        return product;
      } else {
        var tempAttatchmentsText = [];

        try {
          var decodedText = JSON.parse(item.attachments);

          if (decodedText.length > 0) {
            decodedText.forEach(element => {
              var tempFileName = element.split('/');
              tempAttatchmentsText.push({
                file: null,
                base64: element,
                fileName: tempFileName[tempFileName.length - 1],
                type:
                  element.toLowerCase().indexOf('jpg') > -1 ||
                  element.toLowerCase().indexOf('jpeg') > -1 ||
                  element.toLowerCase().indexOf('png') > -1
                    ? 'image'
                    : 'file'
              });
            });
          }
        } catch (e) {
          if (item.attachments != null) {
            if (item.attachments.length > 0) {
              item.attachments.forEach(element => {
                var tempFileName = element.url.split('/');
                tempAttatchmentsText.push({
                  file: null,
                  base64: element.url,
                  fileName: tempFileName[tempFileName.length - 1],
                  type:
                    element.url.toLowerCase().indexOf('jpg') > -1 ||
                    element.url.toLowerCase().indexOf('jpeg') > -1 ||
                    element.url.toLowerCase().indexOf('png') > -1
                      ? 'image'
                      : 'file'
                });
              });
            }
          }
        }

        const text = {
          key: uuidv4(),
          id: tempId,
          type: 'texto',
          attachments: tempAttatchmentsText,
          title: item.name,
          description:
            item.description == null || item.description == 'null' || item.description == ''
              ? ''
              : item.description,
          errors: null,
          order: this.quote.items.length + 1
        };
        return text;
      }
    },

    /* Crear objeto dependiendo de si es producto o texto */
    createObject(type) {
      let product = {
        key: uuidv4(),
        type: 'producto',
        id: null,
        sku: null,
        title: null,
        description: null,
        category: store.state.company.team.category_default,
        tax: true,
        optional: {
          active: false,
          select: false
        },
        discount: {
          amount: null,
          active: false
        },
        suscription: {
          active: false,
          payments: null,
          frequency: 'meses',
          repetition: null
        },
        commission: {
          amount: null,
          active: false
        },
        price: 0,
        quantity: {
          amount: 1,
          edit: false
        },
        total: 0,
        attachments: [],
        errors: null,
        order: this.quote.items.length + 1
      };

      let text = {
        key: uuidv4(),
        id: null,
        type: 'texto',
        attachments: [],
        title: null,
        description: null,
        errors: null,
        order: this.quote.items.length + 1
      };

      if (type === 'producto') {
        return product;
      } else {
        return text;
      }
    },

    checkPermission(permissionToCheck) {
      if (store.getters.permissions != undefined) {
        return store.getters.permissions.indexOf(permissionToCheck) > -1 ? true : false;
      } else {
        return false;
      }
    },

    formatFrequency(repetition, frecuency) {
      let timeString;
      switch (frecuency) {
        case 'meses':
          timeString = repetition > 1 ? 'meses' : 'mes';
          break;
        case 'semanas':
          timeString = repetition > 1 ? 'semanas' : 'semana';
          break;
        case 'quincenas':
          timeString = repetition > 1 ? 'quincenas' : 'quincena';
          break;
        case 'años':
          timeString = repetition > 1 ? 'años' : 'año';
          break;
        default:
          timeString = 'Mensual';
          break;
      }

      return timeString;
    },

    formatStringFrequency(frecuency) {
      let singleString;
      switch (frecuency) {
        case 'meses':
          singleString = 'mensual';
          break;
        case 'semanas':
          singleString = 'semanal';
          break;
        case 'quincenas':
          singleString = 'quincenal';
          break;
        case 'años':
          singleString = 'anual';
          break;
        default:
          singleString = 'mensual';
          break;
      }

      return singleString;
    }
  }
};
